import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'abstract',
    base: `${process.env.VUE_APP_BASE_URL}`,
    routes: [
        // {
        //     path: '/prototype',
        //     name: 'prototype',
        //     component: require('./views/prototype.vue').default
        // },
        {
            path: '/',
            component: require('./components/layout/layout.vue').default,
            children: [
                {
                    path: '',
                    name: 'hello',
                    component: require('./views/game').default
                },
                {
                    path: 'game',
                    component: require('./views/game').default,
                    children: [
                        {
                            path: 'goods',
                            name: 'game-goods',
                            component: require('./views/game').default
                        },
                        {
                            path: 'good/:id',
                            name: 'game-good',
                            component: require('./views/game').default
                        },
                        {
                            path: 'runtime',
                            name: 'game-runtime',
                            component: require('./views/game').default
                        },
                        {
                            path: 'result',
                            name: 'game-result',
                            component: require('./views/game').default
                        }
                    ]
                }
            ]

        }
    ]
})
